





































import {Component, Prop, Vue} from "vue-property-decorator";

import CopyClickWrapper from "@/views/components/CopyClickWrapper.vue";
import {IActiveShipment} from "@/models/StoreModels";
import {namespace} from "vuex-class";
import ShowOneHub from '@/views/components/Home/dropup/ShowOneHub.vue';
import UserPhoneDataPair from "@/views/components/PairData/UserPhoneDataPair.vue";
import ShipmentTypeDataPair from "@/views/components/PairData/ShipmentTypeDataPair.vue";
import DataPair from "@/views/components/PairData/DataPair.vue";
import {errorHandler} from "@/services/services";

const activeShipments = namespace('activeShipments');
const userDataModule = namespace('userData');

@Component({
  name: "ShipmentInfo",
  components: {
    CopyClickWrapper,
    ShowOneHub,
    UserPhoneDataPair,
    ShipmentTypeDataPair,
    DataPair,
  },
})
export default class ShipmentInfo extends Vue {

  @activeShipments.Action('cancelOrder')
  private cancelOrder!: (aoId: string|number) => Promise<any>;

  @userDataModule.Getter('getId')
  private userId!: number;

  @Prop()
  private shipment!: IActiveShipment;

  private close() {
    this.$emit("dialog:clickClose");
  }

  private startDeleteOrder() {
    this.cancelOrder(this.shipment.id)
        .catch(this.showErrors)
      .finally();
    this.close();
  }

  private showErrors(err: any) {
    errorHandler.handleErrorsResponse(err, 'cancelOrder.errors');
  }

}
